<template>
<div class="metal_list">
  <div v-for="item in myMedalsList" :key="item.pk" >
    <img :src="item.medal.image" class="metal_item">
  </div>
</div>

</template>

<script>
import {types as CommunityTypes} from "@/store/modules/community"
import {types as LoginTypes} from "@/store/modules/login"
import {mapState, mapActions, mapGetters, mapMutations} from "vuex"

export default {
  name: 'MyMedal',
  components:{},
  props: {
    myMedalsList:Array,
  },
  data () {
    return {
      data: "hello"
    }
  },
  computed:{
    ...mapState({
      ownerInfo: state => state.login.userInfo,
    })
  },
  methods: {
    ...mapActions({
      fetchOwnInfo: LoginTypes.FETCH_USERINFO,
    })
  },
  mounted () {
    this.fetchOwnInfo()
  }
}
</script>

<style lang="less">
.metal_list{
  display: flex;
  flex-direction:row;
  justify-content: center;
  flex-wrap: wrap;
  margin-top:2rem;
  margin-left:2rem;
  padding-bottom:0.5rem;
  .metal_item{
    width:70%;
    margin-bottom:.5rem;
  }
}
</style>